import React from 'react';
import PropTypes from 'prop-types';
import Icon from './icon';

function PoundBulletIcon(props) {
  const { size } = props;

  return (
    <Icon
      name="pound"
      viewBox="0 0 25 25"
      size={size}
      {...props}
      renderComponent={() => (
        <g id="Group-4">
          <circle id="Oval" fill="#F52828" cx="12" cy="12" r="12" />
          <g
            id="Group-3"
            transform="translate(5.327934, 5.000000)"
            stroke="#F7F7F7"
            strokeWidth="1.5"
          >
            <line
              x1="3.09695712"
              y1="6.297185e-13"
              x2="3.09695712"
              y2="13.344133"
              id="Path"
            />
            <line
              x1="9.7907949"
              y1="6.297185e-13"
              x2="9.7907949"
              y2="13.344133"
              id="Path"
            />
            <line
              x1="13.344133"
              y1="3.44106346"
              x2="-5.24025268e-14"
              y2="3.44106346"
              id="Path"
            />
            <line
              x1="13.344133"
              y1="9.63497769"
              x2="-5.24025268e-14"
              y2="9.63497769"
              id="Path"
            />
          </g>
        </g>
      )}
    />
  );
}

PoundBulletIcon.propTypes = {
  size: PropTypes.number,
};

PoundBulletIcon.defaultProps = {
  size: 25,
};

export default PoundBulletIcon;
